export default [
  {
    // headline: "Earn More with airasia ride!",
    // subheadline: "Join the AirAsia Allstar team as a Rider or Driver and start earning big bucks! You can choose to become an independent Driver or Rider with airasia. You can even opt to become a full-time Driver or Rider. Simpy choose what works the best for you. ",
    // bannerID: "cosmosteam",
    name: "banner1",
    altText: "Earn More with airasia ride!",
    redirectUrl: "",
    desktopImage: "https://www.airasia.com/aa/driver-rider/images/herobanner-dekstop.jpg",
    tabletImage: "https://www.airasia.com/aa/driver-rider/images/herobanner-dekstop.jpg",
    mobileImage: "https://www.airasia.com/aa/driver-rider/images/hero-banner-mobile.jpg"
  }
]
